import type { ReactElement } from 'react'
import styled from 'styled-components'

import { Media } from './Media'
import { LinkText } from '@/components/elements/LinkText'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { MediaKit } from '@/types/mediaKit'

type Props = {
  mediaKit: readonly [string, { data: MediaKit[] }][]
}

export const MediaPage = ({ mediaKit }: Props) => {
  return (
    <Container>
      <SectionTitle
        titleText="Media Kit"
        subTitleText="メディアキット"
        color="normal"
      />
      <Spacer h={{ pc: 63, sp: 50 }} />
      <Description>
        株式会社トライアルホールディングスに関するロゴ・画像データです。
      </Description>
      <Description>
        メディアでご紹介いただく際などに、画像規約の範囲内であれば、ご自由にお使いいただけます。
      </Description>
      <Description>
        ご利用の前に、
        <LinkText path="/legal/image-terms/" text="画像規約" />
        をご確認ください。
      </Description>
      <Spacer h={{ pc: 70, sp: 60 }} />
      <MediaList>
        {mediaKit.map((m) => (
          <Media title={m[0]} mediaList={m[1].data} key={m[0]} />
        ))}
      </MediaList>
    </Container>
  )
}

MediaPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news' },
    { name: 'メディアキット', path: '' },
  ]

  return (
    <>
      <Head
        title="メディアキット"
        description="トライアルホールディングスのメディアキット、ロゴや画像をダウンロードいただけます。"
        ogp={{ type: 'article', url: 'news/media/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const Container = styled.div`
  width: 1040px;
  padding: 70px 0 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    padding: 40px 20px 60px;
    width: 100%;
  }
`

const Description = styled.p`
  font-size: 16px;
  letter-spacing: 0.32px;
  line-height: 30px;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    letter-spacing: 0.3px;
    line-height: 25px;
  }
`

const MediaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;

  @media screen and (max-width: 1047px) {
    gap: 50px;
  }
`
